import classNames from "classnames/bind";
import React, { useEffect, useState } from "react";
import { BaseButton, Tree, Sidebar } from "@velocity-ehs/component-library";
import StatusTag from "../../sharedComponents/StatusTag";
import { TreeNode } from "../../sharedComponents/tree/PrimeTree";
import classes from "../../sharedComponents/tree/PrimeTree.module.scss";

import { useTranslation } from "react-i18next";

interface Props {
  showSlider: boolean;
  orgUnitId?: string;
  closeSliderCallback: () => void;
  linkLocations: (locationIds: string[]) => void;
}

const LinkLocationsSlider: React.FC<Props> = (props) => {
  const cx = classNames.bind(classes);
  const [selected, setSelected] = useState<any>({});
  const [selectedNodeIds, setSelectedNodeIds] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const { t } = useTranslation();

  const handleOnSelect = (event: any) => {
    setSelectedNodeIds((previous) => [...previous, event.node.id]);
  };

  const handleOnUnselect = (event: any) => {
    setSelectedNodeIds((previous) =>
      previous.filter((id) => id !== event.node.id)
    );
  };

  const handleOnRemove = (node: TreeNode) => {
    setSelected((previous: any) => ({
      ...previous,
      [node.key]: { checked: false },
    }));
    handleOnUnselect({ node });
  };

  const nodeTemplate = (node: TreeNode, options: any) => {
    return (
      <>
        <span className={cx(options.className, "includeStatus")}>
          <span>{node.label}</span>
          {node.status !== "Active" && (
            <StatusTag
              status={node.status || ""}
              style={{ marginRight: "10px" }}
            />
          )}
        </span>
      </>
    );
  };

  const handleLinkLocations = async () => {
    setIsSaving(true);
    await props.linkLocations(selectedNodeIds);
    setIsSaving(false);
  };

  useEffect(() => {
    if (!props.showSlider) {
      setSelected({});
      setSelectedNodeIds([]);
    }
  }, [props.showSlider]);

  const content = (
    <div className={"manage-role-assignment-slider"}>
      <h4>{t("action_select_locations")}</h4>
      <Tree
        isMultiSelect
        nodeTemplate={nodeTemplate}
        onSelect={handleOnSelect}
        onUnselect={handleOnUnselect}
        onSelectionChange={(e) => setSelected(e.value)}
        onRemove={handleOnRemove}
        selectionKeys={selected}
      />
    </div>
  );

  const footerButtons = () => {
    return (
      <BaseButton
        onClick={handleLinkLocations}
        label={t("hierarchies_Link")}
        loading={isSaving}
      />
    );
  };

  return (
    <Sidebar
      header={t("hierarchies_Link_Locations")}
      visible={props.showSlider}
      onHide={props.closeSliderCallback}
      footer={footerButtons()}
    >
      {content}
    </Sidebar>
  );
};

export default LinkLocationsSlider;
